import React from 'react';

export default function LayoutListAndDatasheetView({ children }) {
  return (
    <div className="container-fluid p-3">
        {children}
    </div>
  )
}
